import classNames from 'classnames'

import { Link, Skeleton } from '@src/quince-components/src'
import Swiper from '@src/quince-components/src/atoms/custom-swiper'
import { NAV_POSITION } from '@src/quince-components/src/atoms/swiper/Swiper'
import useDeviceInfo, { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'

import { IContentfulCollection } from '../../../types/ContentfulCollectionService.types'
import { getFormattedSlug } from '../../../utils'
import { LinkGroupProps } from '../SubCategoryList'

import styles from './textSubCategoryList.module.scss'

type TextSubCategoryListProps = LinkGroupProps & {
  sendEventOnButtonClick: (filterUsed: string, buttons: IContentfulCollection[]) => void
  className?: string
  contentful_id: string
  isNewCLPFiltersExperimentActive: boolean
  showLoader?: boolean
}

function TextSubCategoryList({
  buttons = [],
  className,
  sendEventOnButtonClick,
  contentful_id,
  isNewCLPFiltersExperimentActive,
  showLoader,
}: TextSubCategoryListProps) {
  const deviceInfo = useDeviceInfo()
  const isDesktop = deviceInfo.deviceType === DEVICE_TYPES.DESKTOP

  if (showLoader && !isDesktop) {
    return (
      <div className={styles.textSubCategorySkeletonWrapper}>
        {new Array(4).fill(0).map((_, index) => (
          <Skeleton key={index} className={styles.textSubCategorySkeleton} />
        ))}
      </div>
    )
  }
  return (
    <div
      className={classNames(
        styles.wrapper,
        isNewCLPFiltersExperimentActive && buttons.length && styles.new_clp_subcategory_links_list,
        className,
      )}
    >
      <Swiper
        showDots={false}
        //TODO: Change showNavigator to true once the slider is fixed to snap to the first tile of the next slide
        showNavigator={false}
        numberOfVisibleSlides={9}
        variableWidth
        id={`textWithProductSlider-${contentful_id}`}
        isChevronIcon
        navPosition={NAV_POSITION.CENTER}
        prevIconClass={styles.prevArrowClass}
        nextIconClass={styles.nextArrowClass}
        arrowWrapperClass={styles.arrowWrapperClass}
        wrapperClass={classNames(styles.swiperWrapper, {
          [`${styles.swiperWrapper__newCLPFilters}`]: isNewCLPFiltersExperimentActive,
        })}
        key={`textWithProductSlider-${contentful_id}`}
      >
        {buttons.map((button, index) => {
          const active = index === 0
          return (
            <Link
              key={button.id}
              className={classNames(styles.subCategoryItem, {
                [`${styles.active}`]: active,
              })}
              href={active ? undefined : '/' + getFormattedSlug(button.slug)}
            >
              <h2
                onClick={() => {
                  sendEventOnButtonClick(button.name, buttons)
                }}
                className={styles.subCategoryItemText}
              >
                {button.name}
              </h2>
            </Link>
          )
        })}
      </Swiper>
    </div>
  )
}

export default TextSubCategoryList
